<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn>
				<!-- v-if="authority_flag" -->
				<v-btn color="white" text @click="$router.push({ name: 'check_sheet_new' })">
					<v-icon class="mr-1">mdi-clipboard-list-outline</v-icon>
					新規チェックリスト作成
				</v-btn>
			</template>
			<CheckSheetSearchSection :query="q" @search-check-sheets="searchCheckSheets($event)" />
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="check_sheets"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openShowPage()">
							<td>{{ item.status_i18n }}</td>
							<td>{{ item.name }}</td>
							<td>{{ common.productNumberByOrderIndividualInfo(item.order_individual_info) }}</td>
							<td>
								{{
									item.order_individual_info.ordered_product
										? common.productNameWithSubName(item.order_individual_info.ordered_product)
										: ""
								}}
							</td>
							<td>
								<span v-for="user in item.order_individual_info.pic_users" :key="user.id">
									{{ user.full_name }}
								</span>
							</td>
							<td>{{ item.issuer.full_name }}</td>
							<td>
								{{
									item.order_individual_info.delivery_info
										? item.order_individual_info.delivery_info.company_name
										: ""
								}}
							</td>
							<td>
								{{
									item.order_individual_info.delivery_info
										? common.formatLocalDateWithDay(
												item.order_individual_info.delivery_info.deadline
										  )
										: ""
								}}
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CheckSheetSearchSection from "./components/CheckSheetSearchSection.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		CheckSheetSearchSection,
	},
	data() {
		return {
			title: "チェックシート一覧",
			check_sheets: [],
			authority_flag: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				order_individual_info_id_eq: null,
				user_id_or_issuer_id_or_check_units_user_id_eq: null,
				status_not_eq: null,
				status_eq: null,
			},
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchCheckSheets(this.q, page, true)
	},
	methods: {
		fetchCheckSheets(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/check_sheets", {
					params,
					headers,
				})
				.then((res) => {
					this.check_sheets = res.data.check_sheets
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchCheckSheets(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchCheckSheets(q) {
			this.q = q
			this.fetchCheckSheets(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		openShowPage() {
			let resolvedRoute = this.$router.resolve({
				name: "check_sheet_show",
				params: { id: 1 },
			})
			window.open(resolvedRoute.href, "_blank")
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}

function headers() {
	return [
		{ text: "状態", value: "status_i18n", width: "120px" },
		{ text: "チェックシート名", value: "name", width: "200px" },
		{ text: "製品番号", value: "product_number", width: "200px" },
		{ text: "製品名", value: "product_name", width: "200px" },
		{ text: "製造担当者", value: "manufacture_user", width: "120px" },
		{ text: "品証担当者", value: "assurance_user", width: "120px" },
		{ text: "納入先", value: "delivery_info.company_name", width: "200px" },
		{ text: "納期", value: "delivery_info.deadline", width: "200px" },
	]
}
</script>
